import { render, staticRenderFns } from "./PatientsFormDiagnosis.vue?vue&type=template&id=7dbab965&"
import script from "./PatientsFormDiagnosis.vue?vue&type=script&lang=js&"
export * from "./PatientsFormDiagnosis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports